<template>
  <section class="product-categories pt-16 md:py-16 text-center">
    <!-- Heading -->
    <div class="product-categories__header max-w-4xl mx-auto">
      <h2 class="heading text-2xl md:text-4xl font-semibold mb-4">
        {{ heading }}
      </h2>
      <p class="sub-heading">
        {{ subheading }}
      </p>
    </div>

    <!-- Grid -->
    <div
      class="product-categories__grid grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-y-12 gap-x-6 max-w-6xl mx-auto py-12"
    >
      <div
        v-for="({ title, icon }, index) in localizedCategories"
        :key="index"
        class="product-categories__item flex flex-col items-center text-center px-2"
      >
        <img
          :src="icon"
          :alt="title"
          class="w-[65px] h-[65px] mb-3 object-contain"
          loading="lazy"
        />
        <p class="text-sm text-gray-800 leading-tight">
          {{ title }}
        </p>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import { computed } from "vue";

const props = defineProps({
  headingKey: {
    type: String,
    default: "categories.heading",
  },
  subheadingKey: {
    type: String,
    default: "categories.subheading",
  },
  categories: {
    type: Array,
    required: true,
    validator: (items) =>
      items.every(
        (item) => typeof item.titleKey === "string" && typeof item.icon === "string"
      ),
  },
});

const { t } = useI18n();

const heading = computed(() => t(props.headingKey));
const subheading = computed(() => t(props.subheadingKey));

const localizedCategories = computed(() =>
  props.categories.map((cat) => ({
    ...cat,
    title: t(cat.titleKey),
  }))
);
</script>

<style scoped>
.heading {
  font-weight: 500;
  text-align: center;
  color: #2e2e2e;
  line-height: 1.3;
  padding-bottom: 10px;
  line-height: 1.3;
}

.sub-heading {
  opacity: 0.8;
  font-size: 14px;
  text-align: center;
  color: #2e2e2e;
  line-height: 1.5;
}
</style>
